export enum HelpCenterContentTypeEnum {
  HELP = 0,
  ARTICLE = 1,
}
